(() => {
  'use strict';
  let detailRoot=null;
  const $=id=>document.getElementById('bve-'+id)||detailRoot?.querySelector('[id="bve-'+id+'"]');
  const breweriesDataElem = $('brewery-data');
  if (!breweriesDataElem) return;
  
  let breweries = [];
  try {
    breweries = JSON.parse(breweriesDataElem.textContent);
  } catch(e) {
    console.error("Fout bij het inladen van brouwerij-data:", e);
    return;
  }

  const provinceData=window.BVE_PROVINCE_DATA||JSON.parse($('province-data').textContent);
  const settings=JSON.parse($('map-settings').textContent);
  detailRoot=$('detail');
  const detailMount=$('detail-mount');
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile=()=>window.matchMedia('(max-width: 900px)').matches;
  const sort=items=>[...items].sort((a,b)=>a.name.localeCompare(b.name,'nl'));
  const normalize=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[’']/g,'');
  const provinceNames=[...new Set(breweries.map(b=>String(b.province||'').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'nl'));
  let selectedProvince='',query='',selectedId=null,highlightedId=null;
  let mapBreweries=sort(breweries),filtered=mapBreweries,searchTimer=0,selectionRequest=0,selectedOrigin=null;
  let cameraProgrammatic=false,zoomStartedAt=7,zoomWasProgrammatic=false,atNationalView=true;
  const cards=new Map(),markers=new Map(),provinceLayers=new Map(),pillButtons=new Map();

  function el(tag,attrs={},text='') {
    const n=document.createElement(tag);for(const [k,v] of Object.entries(attrs))n.setAttribute(k,v);
    if(text)n.textContent=text;return n;
  }
  function icon(name,className='') {
    const n=document.createElementNS('http://www.w3.org/2000/svg','svg');
    n.setAttribute('viewBox','0 0 24 24');n.setAttribute('aria-hidden','true');if(className)n.setAttribute('class',className);
    const use=document.createElementNS(n.namespaceURI,'use');use.setAttribute('href','#bve-'+name);n.append(use);return n;
  }
  function safeUrl(value, allowImage = false) {
    value = String(value || '').trim();
    if (!value) return '';
    if (allowImage && /^data:image\/(png|jpeg|webp|gif);base64,[a-z0-9+/=\s]+$/i.test(value)) return value;
    if (value.startsWith('/')) return value;
    try {
      const u = new URL(value, window.location.origin);
      if (['https:', 'http:'].includes(u.protocol)) return u.href;
    } catch {}
    return '';
  }

  const map=L.map('bve-map',{zoomControl:false,minZoom:6,maxZoom:18,zoomSnap:.25,zoomDelta:1,scrollWheelZoom:true,wheelPxPerZoomLevel:110,preferCanvas:true,zoomAnimation:!reducedMotion,fadeAnimation:!reducedMotion,markerZoomAnimation:!reducedMotion,maxBounds:[[48,-1],[56.5,12]],maxBoundsViscosity:.85});
  map.attributionControl.setPrefix('<a href="https://leafletjs.com/" target="_blank" rel="noopener">Leaflet</a>');
  const countryBounds=L.latLngBounds([[50.73,3.32],[53.6,7.24]]);
  function fitBounds(bounds,maxZoom=14) {
    cameraProgrammatic=true;
    try {map.stop();map.fitBounds(bounds,{paddingTopLeft:[25,90],paddingBottomRight:[25,75],maxZoom,animate:false});}
    finally {cameraProgrammatic=false;}
  }
  fitBounds(countryBounds,8.5);

  let tiles;
  if(settings.provider==='carto'&&settings.cartoApiKey) {
    tiles=L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key='+encodeURIComponent(settings.cartoApiKey),{subdomains:'abcd',maxZoom:18,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions" target="_blank" rel="noopener">CARTO</a>'});
  } else {
    tiles=L.tileLayer('https://service.pdok.nl/kadaster/brt-achtergrondkaart/wmts/v2_0/grijs/EPSG:3857/{z}/{x}/{y}.png',{maxZoom:18,bounds:[[50.5, 3], [53.7, 7.3]],noWrap:true,attribution:'&copy; <a href="https://www.pdok.nl/introductie/-/article/basisregistratie-topografie-achtergrondkaarten-brt-a-" target="_blank" rel="noopener">Kadaster · BRT / PDOK</a>'});
    tiles.getTileUrl=c=>'https://service.pdok.nl/kadaster/brt-achtergrondkaart/wmts/v2_0/grijs/EPSG:3857/'+String(c.z).padStart(2,'0')+'/'+c.x+'/'+c.y+'.png';
  }
  let tileErrors=0;
  tiles.on('tileerror',()=>{if(++tileErrors>=3)$('map-warning').hidden=false;});
  tiles.on('tileload',()=>{tileErrors=0;$('map-warning').hidden=true;});
  tiles.addTo(map);

  /* HIER ZITTEN DE ORIGINELE WARME INKLEUR-STIJLEN VOOR DE PROVINCIES */
  function provinceStyle(name) {
    const active = name === selectedProvince;
    const isAnyActive = Boolean(selectedProvince);
    
    return {
      color: active ? '#B45309' : (isAnyActive ? '#CBD5E1' : '#D97706'),
      weight: active ? 2.2 : 1,
      opacity: active ? 1 : 0.6,
      fillColor: active ? '#F59E0B' : '#FDE8C8',
      fillOpacity: active ? 0.35 : (isAnyActive ? 0.12 : 0.28),
      bubblingMouseEvents: false
    };
  }

  L.geoJSON(provinceData,{
    style: f => provinceStyle(f.properties.name),
    onEachFeature: (feature, layer) => {
      const name = feature.properties.name;
      provinceLayers.set(name, layer);
      
      layer.on('click', e => {
        if(e.originalEvent) L.DomEvent.stopPropagation(e.originalEvent);
        if(map.getZoom() > 10) { map.closePopup(); return; }
        selectProvince(selectedProvince === name ? '' : name);
      });
      
      layer.on('mouseover', () => {
        if(selectedProvince !== name) {
          layer.setStyle({
            fillColor: '#FBBF24',
            fillOpacity: 0.45,
            color: '#B45309',
            weight: 1.8
          });
        }
      });
      
      layer.on('mouseout', () => layer.setStyle(provinceStyle(name)));
    }
  }).addTo(map);

  const pinHtml='<span class="bve-pin"><svg viewBox="0 0 40 48" aria-hidden="true"><ellipse class="bve-pin-ring" cx="20" cy="19" rx="21" ry="21"/><path class="bve-pin-body" d="M20 1.5C9.8 1.5 2.5 9.1 2.5 18.5c0 12 17.5 27.5 17.5 27.5S37.5 30.5 37.5 18.5C37.5 9.1 30.2 1.5 20 1.5Z"/><path d="M17.5 9.5h5v6c0 1.7 3 2.6 3 5.3v8.5c0 1.2-.8 1.7-2 1.7h-7c-1.2 0-2-.5-2-1.7v-8.5c0-2.7 3-3.6 3-5.3Zm-1 12h7v5h-7Zm1-14h5" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  const pinIcon=L.divIcon({html:pinHtml,className:'bve-marker-icon',iconSize:[40,48],iconAnchor:[20,46],tooltipAnchor:[0,-46]});
  const clusters=L.markerClusterGroup({maxClusterRadius:45,showCoverageOnHover:false,spiderfyOnMaxZoom:true,zoomToBoundsOnClick:true,animate:!reducedMotion,spiderfyDistanceMultiplier:1.6,spiderLegPolylineOptions:{weight:1.5,color:'#D97706',opacity:.65},iconCreateFunction:cluster=>{
    const active=cluster.getAllChildMarkers().some(m=>m.options.breweryId===selectedId);
    return L.divIcon({html:'<span class="bve-cluster-bubble'+(active?' is-active':'')+'">'+cluster.getChildCount()+'</span>',className:'bve-cluster-icon',iconSize:[46,46],iconAnchor:[23,23]});
  }}).addTo(map);
  const popup=L.popup({className:'bve-brewery-popup',closeButton:false,minWidth:260,maxWidth:350,offset:[0,-43],autoPanPaddingTopLeft:[16,80],autoPanPaddingBottomRight:[16,30],closeOnEscapeKey:true}).setContent(detailRoot);

  function makeMarker(b) {
    const marker=L.marker([b.lat,b.lng],{icon:pinIcon,title:b.name+' · '+b.city,alt:b.name+' in '+b.city,keyboard:true,breweryId:b.id,riseOnHover:true});
    marker.bindTooltip(el('span',{},b.name),{direction:'top',offset:[0,-4],className:'bve-marker-tooltip'});
    marker.on('click',e=>openBrewery(b,marker.getElement(),e.originalEvent?.detail===0));
    marker.on('mouseover',()=>{highlightedId=b.id;syncSelection();});
    marker.on('mouseout',()=>{highlightedId=null;syncSelection();});
    marker.on('add',()=>syncMarker(marker));
    return marker;
  }
  for(const b of breweries)markers.set(b.id,makeMarker(b));

  function syncMarker(marker) {
    const element=marker.getElement();if(!element)return;
    const id=marker.options.breweryId;
    element.classList.toggle('is-active',id===selectedId);element.classList.toggle('is-highlight',id===highlightedId);
    element.setAttribute('aria-expanded',String(id===selectedId));element.setAttribute('aria-haspopup','dialog');
    marker.setZIndexOffset(id===selectedId?1000:0);
  }

  function syncSelection() {
    for(const [id,card] of cards){card.setAttribute('aria-expanded',String(id===selectedId));card.classList.toggle('is-highlight',id===highlightedId);}
    for(const marker of markers.values())syncMarker(marker);
    clusters.refreshClusters();
  }

  function updateMapBreweries() {
    clusters.clearLayers();clusters.addLayers(mapBreweries.map(b=>markers.get(b.id)));
    $('map-empty').hidden=mapBreweries.length>0;syncSelection();
  }

  function cardFor(b) {
    const card=el('button',{type:'button',class:'bve-card','data-id':b.id,'aria-expanded':String(b.id===selectedId),'aria-haspopup':'dialog','aria-controls':'bve-detail'});
    const head=el('span',{class:'bve-card-head'}),thumb=el('span',{class:'bve-card-thumb','aria-hidden':'true'}),url=safeUrl(b.image,true);
    if(url){const image=el('img',{src:url,alt:'',width:'56',height:'56',loading:'lazy',decoding:'async'});if(b.imageFit==='cover')image.classList.add('bve-photo');image.addEventListener('error',()=>thumb.replaceChildren(icon('bottle-line')),{once:true});thumb.append(image);}else thumb.append(icon('bottle-line'));
    const copy=el('span',{class:'bve-card-heading'}),city=el('span',{class:'bve-card-city'});
    city.append(icon('location-icon'),document.createTextNode(b.city));copy.append(el('strong',{class:'bve-card-name'},b.name),city);head.append(thumb,copy);
    const foot=el('span',{class:'bve-card-foot'}),indicator=el('span',{class:'bve-card-indicator'});
    indicator.append(el('span',{class:'bve-card-default-label'},'Ontdekken'),el('span',{class:'bve-card-selected-label'},'Geselecteerd'),icon('arrow-icon'));
    foot.append(el('span',{},b.province),indicator);card.append(head,el('span',{class:'bve-card-story'},b.story),foot);
    card.addEventListener('click',e=>openBrewery(b,card,e.detail===0));
    for(const event of ['pointerenter','focus'])card.addEventListener(event,()=>{highlightedId=b.id;syncSelection();});
    for(const event of ['pointerleave','blur'])card.addEventListener(event,()=>{highlightedId=null;syncSelection();});
    return card;
  }

  function updatePillScroll() {
    const n=$('province-pills');$('pills-prev').disabled=n.scrollLeft<=2;$('pills-next').disabled=n.scrollLeft+n.clientWidth>=n.scrollWidth-2;
  }

  function buildPills() {
    const track=$('province-pills');track.replaceChildren();pillButtons.clear();
    for(const name of ['',...provinceNames]) {
      const pill=el('button',{type:'button',class:'bve-pill','aria-pressed':String(name===selectedProvince),'data-province':name});
      pill.append(el('span',{},name||'Alle'),el('span',{class:'bve-pill-count'},String(name?mapBreweries.filter(b=>b.province===name).length:mapBreweries.length)));
      pill.addEventListener('click',()=>selectProvince(name===selectedProvince?'':name));track.append(pill);pillButtons.set(name,pill);
    }
    requestAnimationFrame(updatePillScroll);
  }

  function renderResults(resetScroll=false) {
    filtered=mapBreweries.filter(b=>!selectedProvince||b.province===selectedProvince);
    const list=$('list-items'),oldScroll=list.scrollTop;list.replaceChildren();cards.clear();
    for(const b of filtered){const card=cardFor(b);cards.set(b.id,card);list.append(card);}
    if(!filtered.length){const empty=el('div',{class:'bve-empty'}),elsewhere=!!(selectedProvince&&mapBreweries.length);empty.append(el('strong',{},'Geen brouwerijen gevonden'),el('p',{},elsewhere?'Er zijn wel brouwerijen gevonden in andere provincies.':'Probeer een andere naam of plaats.'));const clear=el('button',{type:'button',class:'bve-text-button'},elsewhere?'Zoek in heel Nederland':'Toon alle brouwerijen');clear.addEventListener('click',()=>elsewhere?selectProvince(''):resetAll());empty.append(clear);list.append(empty);}
    list.scrollTop=resetScroll?0:oldScroll;
    $('list-title').textContent=selectedProvince||(query?'Zoekresultaten':'Alle brouwerijen');
    $('count').textContent=filtered.length+' '+(filtered.length===1?'brouwerij':'brouwerijen')+(query?' gevonden':' om te ontdekken');
    $('total').textContent=breweries.length;$('reset').hidden=!(query||selectedProvince);$('search-clear').hidden=!query;
    $('map-context').hidden=!(selectedProvince||query);$('map-context').textContent=selectedProvince||(query?'Zoekresultaten':'');
    for(const [name,pill] of pillButtons)pill.setAttribute('aria-pressed',String(name===selectedProvince));
    for(const [name,layer] of provinceLayers)layer.setStyle(provinceStyle(name));
    syncSelection();
  }

  function clearProvince() {if(!selectedProvince)return;selectedProvince='';renderResults(true);}
  function selectProvince(name) {
    clearTimeout(searchTimer);closeDetails(false);selectedProvince=name;renderResults(true);
    const pill=pillButtons.get(name),track=$('province-pills');if(pill)track.scrollTo({left:Math.max(0,pill.offsetLeft-track.offsetLeft-(track.clientWidth-pill.offsetWidth)/2),behavior:reducedMotion?'auto':'smooth'});
    atNationalView=!name&&!query;
    if(name&&filtered.length)fitBounds(L.latLngBounds(filtered.map(b=>[b.lat,b.lng])),11);
    else if(query&&mapBreweries.length)fitBounds(L.latLngBounds(mapBreweries.map(b=>[b.lat,b.lng])),14);
    else fitBounds(countryBounds,8.5);
  }

  function resetAll() {
    clearTimeout(searchTimer);closeDetails(false);query='';selectedProvince='';$('search').value='';mapBreweries=sort(breweries);buildPills();renderResults(true);updateMapBreweries();atNationalView=true;fitBounds(countryBounds,8.5);
  }

  function searchChanged() {
    clearTimeout(searchTimer);closeDetails(false);query=$('search').value.trim();selectedProvince='';
    const needle=normalize(query);mapBreweries=sort(breweries.filter(b=>!needle||normalize(b.name+' '+b.city+' '+b.province).includes(needle)));
    buildPills();renderResults(true);updateMapBreweries();atNationalView=!query;
    searchTimer=setTimeout(()=>{if(!query)fitBounds(countryBounds,8.5);else if(mapBreweries.length)fitBounds(L.latLngBounds(mapBreweries.map(b=>[b.lat,b.lng])),14);},200);
  }

  function populateDetail(b) {
    $('detail-title').textContent = b.name;
    $('detail-location').textContent = b.city + ' · ' + b.province;
    $('story').textContent = b.story || '';

    $('status-note').hidden = !b.statusNote;
    $('status-note').replaceChildren();
    if (b.statusNote) {
      $('status-note').append(document.createTextNode(b.statusNote + ' '));
    }

    const badges = [];
    if (b.year) badges.push(el('span', {}, 'Sinds ' + b.year));
    if (b.kind) badges.push(el('span', {}, b.kind));
    $('badges').replaceChildren(...badges);

    const img = $('detail-image'), fallback = $('image-fallback'), url = safeUrl(b.image, true);
    img.hidden = true; fallback.hidden = false; img.alt = b.imageAlt || b.name;
    img.classList.toggle('bve-photo', b.imageFit === 'cover');
    img.onload = () => { img.hidden = false; fallback.hidden = true; if (popup.isOpen()) popup.update(); };
    img.onerror = () => { img.hidden = true; fallback.hidden = false; };
    if (url) img.src = url; else img.removeAttribute('src');

    $('address').textContent = b.address || b.city;
    $('location-note').textContent = b.locationPrecision === 'address' ? 'Vestigingsadres.' : 'Locatie op plaatsniveau; dit is geen exact bezoekadres.';

    const targetUrl = b.orderUrl || b.contentSource || '';
    const allLinks = document.querySelectorAll('#bve-order, [id="bve-order"]');
    
    allLinks.forEach(link => {
      if (link.parentElement) {
        link.parentElement.style.setProperty('display', 'flex', 'important');
        link.parentElement.style.setProperty('grid-template-columns', 'none', 'important');
        link.parentElement.style.setProperty('width', '100%', 'important');
      }
      link.style.setProperty('width', '100%', 'important');
      link.style.setProperty('display', 'flex', 'important');
      link.style.setProperty('justify-content', 'center', 'important');

      if (targetUrl) {
        link.hidden = false;
        link.setAttribute('href', targetUrl);
        const btnText = (b.statusNote && b.statusNote.length > 0) ? 'Bekijk verhaal ' : 'Bekijk brouwerij ';
        link.replaceChildren(document.createTextNode(btnText), icon('arrow-icon'));

        link.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = targetUrl;
        };
      } else {
        link.hidden = true;
      }
    });
  }

  function openBrewery(b,origin,keyboard=false) {
    clearTimeout(searchTimer);if(selectedProvince&&b.province!==selectedProvince)clearProvince();
    selectedId=b.id;selectedOrigin=origin;highlightedId=null;atNationalView=false;const request=++selectionRequest;
    populateDetail(b);syncSelection();const marker=markers.get(b.id);
    detailRoot.style.maxHeight=Math.max(230,Math.min(620,map.getSize().y-170))+'px';
    if(isMobile())$('map-panel').scrollIntoView({behavior:reducedMotion?'auto':'smooth',block:'start'});
    const card=cards.get(b.id);if(card&&!isMobile()){const list=$('list-items'),a=card.getBoundingClientRect(),r=list.getBoundingClientRect();if(a.top<r.top||a.bottom>r.bottom)list.scrollTo({top:list.scrollTop+a.top-r.top-8,behavior:reducedMotion?'auto':'smooth'});}
    clusters.zoomToShowLayer(marker,()=>{
      if(request!==selectionRequest||selectedId!==b.id)return;
      popup.setLatLng(marker.getLatLng()).setContent(detailRoot).openOn(map);
      
      populateDetail(b);

      if (popup.getElement()) {
        L.DomEvent.disableClickPropagation(popup.getElement());
      }

      const p=popup.getElement();p.setAttribute('role','dialog');p.setAttribute('aria-modal','false');p.setAttribute('aria-labelledby','bve-detail-title');
      $('detail-scroll').scrollTop=0;syncSelection();
      if(keyboard)$('detail-close').focus({preventScroll:true});
    });
  }

  let restoreFocus=true;
  function closeDetails(focus=true) {
    selectionRequest++;restoreFocus=focus;
    if(popup.isOpen())map.closePopup(popup);
    else{selectedId=null;highlightedId=null;syncSelection();}
    restoreFocus=true;
  }

  map.on('popupclose',e=>{
    if(e.popup!==popup)return;detailMount.append(detailRoot);selectedId=null;highlightedId=null;selectionRequest++;syncSelection();
    if(restoreFocus&&selectedOrigin?.isConnected)selectedOrigin.focus({preventScroll:true});
  });

  $('detail-close').addEventListener('click',()=>closeDetails());
  detailRoot.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();closeDetails();}});
  map.on('zoomstart',()=>{zoomStartedAt=map.getZoom();zoomWasProgrammatic=cameraProgrammatic;if(!cameraProgrammatic)atNationalView=false;});
  map.on('zoomend',()=>{
    if(!zoomWasProgrammatic&&map.getZoom()<zoomStartedAt-.01)clearProvince();
    $('zoom-in').disabled=map.getZoom()>=map.getMaxZoom();$('zoom-out').disabled=map.getZoom()<=map.getMinZoom();
    for(const [name,layer] of provinceLayers)layer.setStyle(provinceStyle(name));syncSelection();
  });
  map.on('dragstart',()=>{atNationalView=false;});
  $('zoom-in').addEventListener('click',()=>{clearTimeout(searchTimer);atNationalView=false;map.zoomIn();});
  $('zoom-out').addEventListener('click',()=>{clearTimeout(searchTimer);atNationalView=false;clearProvince();map.zoomOut();});
  $('home').addEventListener('click',resetAll);$('reset').addEventListener('click',resetAll);$('empty-reset').addEventListener('click',resetAll);
  $('search').addEventListener('input',searchChanged);$('search-clear').addEventListener('click',()=>{$('search').value='';searchChanged();$('search').focus();});
  $('show-map').addEventListener('click',()=>$('map-panel').scrollIntoView({behavior:reducedMotion?'auto':'smooth',block:'start'}));
  $('province-pills').addEventListener('scroll',updatePillScroll,{passive:true});
  for(const [id,direction] of [['pills-prev',-1],['pills-next',1]])$(id).addEventListener('click',()=>$('province-pills').scrollBy({left:direction*260,behavior:reducedMotion?'auto':'smooth'}));
  let resizeFrame=0;
  new ResizeObserver(()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(()=>{map.invalidateSize({pan:false});if(atNationalView)fitBounds(countryBounds,8.5);detailRoot.style.maxHeight=Math.max(230,Math.min(620,map.getSize().y-170))+'px';if(popup.isOpen())popup.update();updatePillScroll();});}).observe($('map-panel'));

  buildPills();renderResults();updateMapBreweries();
  const settleInitialMap=()=>{
    if(!atNationalView||query||selectedProvince||selectedId)return;
    map.invalidateSize({pan:false});
    fitBounds(countryBounds,8.5);
  };
  requestAnimationFrame(()=>requestAnimationFrame(settleInitialMap));
  window.addEventListener('load',settleInitialMap,{once:true});
  setTimeout(settleInitialMap,300);
})();